module.exports = __webpack_public_path__ + "static/media/c7.21f06109.jpg";